import React from "react";
import PropTypes from "prop-types";
import { Steps, Icon, Button } from "antd";
import { List } from "immutable";

class ExpandableSteps extends React.Component {
    state = {
        showAll: true
    }
    filteredOptions = List([]);
    componentDidMount() {
        this.filteredOptions = this.props.options;
        this.forceUpdate();
    }
    componentDidUpdate(prevProps) {
        if(this.props.options.size > prevProps.options.size) {
            this.filteredOptions = this.props.options;
            this.forceUpdate();
        }
    }
    toggleShowAll = () => {
        if(this.state.showAll) {
            this.filteredOptions = this.props.options.filter(_ => !_.key || _.stage_name === this.props.currentStage.stage_name);
        } else {
            this.filteredOptions = this.props.options;
        }
        this.setState({
            showAll: !this.state.showAll
        });
    }

    

    onChange = activeIndex => {
        const stage = this.filteredOptions.find((_, index) => index === activeIndex);
        this.props.onTabChange(stage);
    }
    render() {
        const { currentStage } = this.props;
        const currentStageIndex = this.filteredOptions.findIndex(_ => _.stage_name === currentStage.stage_name);
        return(
            <div className={"d-flex flex-row bg-white"}>
                <div style={{ padding: "4px 14px" }}>
                    <Button 
                        type={"link"} 
                        icon={this.state.showAll ? "minus-circle" : "plus-circle"} 
                        onClick={this.toggleShowAll}
                    />
                </div>
                <div style={{ overflowX: "auto" }}>
                    <Steps
                        className={"stage-tabs"}
                        type={"navigation"}
                        size={"small"}
                        current={currentStageIndex}
                        onChange={this.onChange}
                        style={this.props.style}
                    >
                        {this.filteredOptions.map(_ => {
                            return (
                                <Steps.Step
                                    status={null}
                                    key={_.id}
                                    description={!_.key ? (<i> {"You work here"}</i>) : null}
                                    title={
                                        <div className="d-flex justify-content-space-between" style={{
                                            alignItems: "start",
                                            width: "100%"
                                        }}>
                                            <div>{_ && _.stage_name}</div>
                                            {this.props.toggleHelp ? <Icon type="info-circle" /> : null}
                                        </div>
                                    }
                                />
                            );
                        }).toArray()}
                    </Steps>
                </div>
            </div>
        );
    }
}

ExpandableSteps.propTypes = {
    onTabChange: PropTypes.func,
    currentStage: PropTypes.oneOfType([PropTypes.object, PropTypes.number]),
    style: PropTypes.object,
    toggleHelp: PropTypes.bool,
    options: PropTypes.object,
};

export default ExpandableSteps;